import React, { useCallback } from 'react';
import { Container, Checkbox, Label } from './styles';

export type IncludeInactiveToggleProps = {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  isDisabled?: boolean;
};

const IncludeInactiveToggle: React.FC<IncludeInactiveToggleProps> = ({
  checked,
  onChange,
  label,
  isDisabled,
}) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (isDisabled) return;
      onChange(e.target.checked);
    },
    [onChange, isDisabled],
  );

  return (
    <Container $isDisabled={isDisabled}>
      <Checkbox
        checked={checked}
        onChange={handleChange}
        disabled={isDisabled}
        aria-label={label}
      />
      <Label>{label}</Label>
    </Container>
  );
};

export default IncludeInactiveToggle;
